import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useForm, usePublisherList } from '../../../utils/custom-hooks';

import DropdownSelect from '../../ui/dropdown';
import ChippedInput from '../../ui/form-elements/text-input/chipped-input';
import Button from '../../ui/button';
import SKUInput from './sku-input';

import './strategy-creation.scss';

const TARGET_LIST_TYPE_OPTIONS = [
  { label: 'SKU', value: 'sku' },
  { label: 'Brand', value: 'brand' },
  { label: 'Publisher', value: 'publisher' },
  { label: 'Merchant Category', value: 'merchant_category' },
  { label: 'Google Category', value: 'google_category' },
];

const OPERATOR_OPTIONS = [
  // {label: 'Equals', value: '_eq'}, // 1
  // {label: 'Not Equals', value: '_ne'}, // 2
  // {label: 'Greater Than', value: '_gt'}, // ...
  // {label: 'Less Than', value: '_lt'},
  // {label: 'Greater Than or Equal To', value: '_ge'},
  // {label: 'Less Than or Equal To', value: '_le'},
  { label: 'Equals any of', value: '_in' },
  { label: 'Not equals any of', value: '_nin' },
  // {label: 'Like', value: '_like'},
];

const TargetExpressionInput = props => {
  const { onChange, name, onRemove, value, errors, pubList, pubMap, selectedTypes } = props;
  const [listType, setListType] = useState();
  const [operator, setOperator] = useState();

  const { values, setValues, handleChange } = useForm();

  useEffect(() => {
    const listIdx = TARGET_LIST_TYPE_OPTIONS.findIndex(
      option => option.value === value.target_list_type,
    );
    if (listIdx >= 0) {
      setListType(TARGET_LIST_TYPE_OPTIONS[listIdx]);
    }

    const operatorIdx = OPERATOR_OPTIONS.findIndex(
      option => option.value === value.target_rule_operator,
    );
    if (operatorIdx >= 0) {
      setOperator(OPERATOR_OPTIONS[operatorIdx]);
    }

    setValues(value);
  }, [value]);

  const handleInputChange = value => {
    const newValues = handleChange(value);

    if (value.target.name === 'target_list_type') {
      newValues.target_list_items = [];
      newValues.target_list = [];
      newValues.target_list_id = null;
    }

    if (value.target.name === 'target_list' && newValues.target_list_type === 'sku') {
      newValues.target_list_items = newValues.target_list.map(item => item.target_sku);
    }

    onChange({ target: { name, value: newValues } });
  };

  const getListOptions = listType => {
    if (listType === 'publisher') {
      return [...pubList];
    }

    return null;
  };

  const getOptionsMap = listType => {
    if (listType === 'publisher') {
      return { ...pubMap };
    }

    return null;
  };

  return (
    <div className="target-expression-input">
      <div className="inputs">
        <div className="list-type-dropdown">
          <DropdownSelect
            name="target_list_type"
            items={TARGET_LIST_TYPE_OPTIONS.filter(option => !selectedTypes.includes(option.value))}
            onChange={handleInputChange}
            formElement={true}
            onSelect={setListType}
            styleType="bordered"
            label={listType ? listType.label : 'Select Type'}
            value={values.target_list_type}
          />
        </div>
        <div className="operator-dropdown">
          <DropdownSelect
            name="target_rule_operator"
            onChange={handleInputChange}
            formElement={true}
            items={OPERATOR_OPTIONS}
            onSelect={setOperator}
            styleType="bordered"
            label={operator ? operator.label : 'Select Operator'}
            value={values.target_rule_operator}
          />
        </div>
        {values.target_list_type === 'sku' ? (
          <SKUInput
            name="target_list"
            targetList={values.target_list || []}
            value={values.target_list_items}
            onChange={handleInputChange}
            maxlength={512}
          />
        ) : (
          <ChippedInput
            name="target_list_items"
            onChange={handleInputChange}
            value={values.target_list_items}
            options={getListOptions(values.target_list_type)}
            optionsMap={getOptionsMap(values.target_list_type)}
            disableManualInput={values.target_list_type === 'publisher'}
            chipType={values.target_list_type}
            maxlength={512}
          />
        )}

        <Button kind="text" iconOnly="x" size="small" onClick={() => onRemove(name)} />
      </div>
      <div className="error-messages">
        {errors && errors.map(message => <div key={message}>{message}</div>)}
      </div>
    </div>
  );
};

export default TargetExpressionInput;
